import React from 'react';
import { Box, VStack, Text } from '@chakra-ui/react';
import { motion, AnimatePresence } from 'framer-motion';
import ChoiceButton from './ChoiceButton';
import { surveyTheme as theme } from './surveyTheme';

const MotionBox = motion(Box);

/**
 * QuestionCard - Displays a single survey question with choices
 *
 * Uses a simple crossfade transition between questions.
 * No sliding, no stagger - just clean and fast.
 */
const QuestionCard = ({
  question,
  questionNumber,
  totalQuestions,
  selectedChoice,
  onChoiceSelect,
}) => {
  return (
    <AnimatePresence mode="wait">
      <MotionBox
        key={question.id}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.25, ease: 'easeOut' }}
        width="100%"
        maxW="560px"
        mx="auto"
        px={theme.spacing.screenPadding}
      >
        <VStack spacing={theme.spacing.questionGap} align="stretch">
          {/* Question header */}
          <Box>
            <Text
              fontSize={theme.typography.progress.fontSize}
              fontWeight={theme.typography.progress.fontWeight}
              letterSpacing={theme.typography.progress.letterSpacing}
              color={theme.colors.textMuted}
              mb={3}
              fontFamily={theme.typography.fontFamily}
            >
              Question {questionNumber} of {totalQuestions}
            </Text>
            <Text
              as="h2"
              fontSize={theme.typography.question.fontSize}
              fontWeight={theme.typography.question.fontWeight}
              lineHeight={theme.typography.question.lineHeight}
              color={theme.colors.textPrimary}
              fontFamily={theme.typography.fontFamily}
            >
              {question.text}
            </Text>
          </Box>

          {/* Choices */}
          <VStack spacing={theme.spacing.choiceGap} align="stretch" role="radiogroup">
            {question.choices.map((choice) => (
              <ChoiceButton
                key={choice.id}
                choice={choice}
                isSelected={selectedChoice === String(choice.id)}
                onSelect={(id) => onChoiceSelect(question.id, String(id))}
              />
            ))}
          </VStack>
        </VStack>
      </MotionBox>
    </AnimatePresence>
  );
};

export default QuestionCard;
